<template>
  <v-fade-transition mode="out-in">
    <v-icon
      :key="$vuetify.theme.dark"
      @click="toggleTheme"
      class="v-icon--link"
      style="cursor: pointer;"
    >
      {{ $vuetify.theme.dark ? icons.mdiWeatherSunny : icons.mdiWeatherNight }}
    </v-icon>
  </v-fade-transition>
</template>

<script>
import { mdiWeatherNight, mdiWeatherSunny } from '@mdi/js'

export default {
  setup() {
    return {
      icons: {
        mdiWeatherNight,
        mdiWeatherSunny,
      },
    }
  },
  methods: {
    toggleTheme() {
      // Toggle the theme
      const newThemeIsDark = !this.$vuetify.theme.dark
      
      // Update document element class immediately BEFORE toggling Vuetify theme
      if (newThemeIsDark) {
        document.documentElement.classList.add('theme--dark')
      } else {
        document.documentElement.classList.remove('theme--dark')
      }
      
      // Apply styles immediately to prevent flash
      const styleId = 'theme-switcher-dynamic-styles'
      let styleElement = document.getElementById(styleId)
      if (!styleElement) {
        styleElement = document.createElement('style')
        styleElement.id = styleId
        document.head.appendChild(styleElement)
      }
      
      if (newThemeIsDark) {
        // Apply dark theme styles immediately
        styleElement.textContent = 
          '.v-application.theme--dark { background-color: #28243d !important; } ' +
          '.v-card, .v-sheet { background-color: #312d4b !important; } ' +
          '.v-data-table { background-color: #312d4b !important; } ' +
          '.v-data-table th { background-color: #3b355a !important; } ' +
          '.v-application.theme--dark .v-data-table th { background-color: #3b355a !important; } ' +
          '.velmld-overlay { background-color: rgba(40, 36, 61, 0.9) !important; } ' +
          '.velmld-full-screen { background-color: rgba(40, 36, 61, 0.9) !important; }'
      } else {
        // Apply light theme styles immediately
        styleElement.textContent = 
          'body { background-color: #f4f5fa !important; } ' +
          '.v-application.theme--light { background-color: #f4f5fa !important; } ' +
          '.v-card, .v-sheet { background-color: #ffffff !important; } ' +
          '.v-data-table { background-color: #ffffff !important; } ' +
          '.v-data-table th { background-color: #f5f5f5 !important; } ' +
          '.velmld-overlay { background-color: rgba(255, 255, 255, 0.9) !important; } ' +
          '.velmld-full-screen { background-color: rgba(255, 255, 255, 0.9) !important; }'
      }
      
      // Now toggle Vuetify theme (this will trigger Vue reactivity)
      this.$vuetify.theme.dark = newThemeIsDark
      
      // Save theme preference to localStorage
      try {
        if (typeof window !== 'undefined' && window.localStorage) {
          localStorage.setItem('theme', newThemeIsDark ? 'dark' : 'light')
        }
      } catch (e) {
        console.warn('Could not save theme preference to localStorage:', e)
      }
    },
  },
}
</script>

<style scoped>
.v-icon--link {
  cursor: pointer;
  user-select: none;
}
.v-icon--link:hover {
  opacity: 0.8;
}
</style>
